AFRAME.registerComponent('nearby-dom', {
    schema: {
        radius: {
            type: 'number',
            default: 1
        },
        target: {
            type: 'selector'
        },
        class: {
            type: 'string',
            default: 'active'
        }
    },
    init: function () {
        this.tick = AFRAME.utils.throttleTick(this.tick, 100, this);
        this._nearby = false;
        this.cameraPosition = new THREE.Vector3();
        this.position = new THREE.Vector3();
    },
    tick: function () {
        const radius = this.data.radius;
        this.el.object3D.getWorldPosition(this.position);
        document.querySelector('[camera]').object3D.getWorldPosition(this.cameraPosition);
        const dx = this.position.x - this.cameraPosition.x;
        const dz = this.position.z - this.cameraPosition.z;
        let nearby = false;
        if (dx * dx + dz * dz < radius * radius) {
            nearby = true;
        }
        
        if (nearby != this._nearby) {
            this._nearby = nearby;
            if (nearby) {
                this.data.target.classList.add(this.data.class);
            } else {
                this.data.target.classList.remove(this.data.class);
            }
        }
    },
});